import BaseService from "./base.service";

export default class ArticlesCategoriesService extends BaseService {
	constructor() {
		super("artigos/categorias");
	}
}
